import MonitorConsole from "./components/MonitorConsole";
import VehicleLabel from "./components/VehicleLabel";
import FourVehicleLayout from "./components/FourVehicleLayout";
import BaseInfo from "./components/BaseInfo";
import "../CommonDesign.scss";

interface SystemSettingProps {
  baseId: number | null;
}

const SystemSetting = ({ baseId }: SystemSettingProps) => {
  return (
    <div className="systemSetting">
      <div className="content">
        <div className="title">システム設定</div>
        <BaseInfo baseId={baseId} />
        <MonitorConsole baseId={baseId} />
        <VehicleLabel baseId={baseId} />
        <FourVehicleLayout baseId={baseId} />
      </div>
    </div>
  );
};

export default SystemSetting;
